// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-badge":"sapcnqr-badge-2387fb","sapcnqr-badge--muted":"sapcnqr-badge--muted-68e62d"};